import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import Question from './components/Question';
import Quiz from './components/Quiz';
import Result from './components/Result';
import quizQuestions from './api/quizQuestions';
import shadeInfo from './api/shadeInfo';
import Introduction from './components/Introduction';
import Explanation from './components/Explanation';
import Skintone from './components/Skintone';
import ModelSelect from './components/ModelSelect';
import Loading from './components/Loading';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter: 0,
      questionId: 1,
      question: '',
      answerOptions: [],
      answer: '',
      value: '',
      answersCount: {},
      shadeResult: '',
      shadeResultPolished: '',
      shadeColor: '',
      shadeLink: '',
      shadeImage: '',
      productResult: '',
      modelSelected: '',
      brushImage: '',
      brushLink: '',
      brush: '',
      answerOne: '',
      answerTwo: '',
      answerThree: '',
      pageId: 0
    };

    this.handleAnswerSelected = this.handleAnswerSelected.bind(this);
    this.handleModelSelected = this.handleModelSelected.bind(this);
    this.handleContinueSelected = this.handleContinueSelected.bind(this);
    this.handleBackSelected = this.handleBackSelected.bind(this);
    this.handleBackQuizSelected = this.handleBackQuizSelected.bind(this);
    this.handleLoadingSelected = this.handleLoadingSelected.bind(this);
  }

  componentDidMount() {
    const answerOptions = quizQuestions.map((question) => question.answers);
  
    this.setState({
      question: quizQuestions[0].question,
      answerOptions: answerOptions[0]
    });
  }
  
	componentDidUpdate() {
		window.scrollTo(0, 0);
	}

  setUserAnswer(answer) {
    this.setState((state) => ({
      answersCount: {
        ...state.answersCount,
        [answer]: (state.answersCount[answer] || 0) + 1
      },
      answer: answer
    }), () => console.log(this.state.answersCount));
  }

  setPreviousQuestion() {
    const counter = this.state.counter - 1;
    const questionId = this.state.questionId - 1;
    this.setState({
      counter: counter,
      questionId: questionId,
      question: quizQuestions[counter].question,
      answerOptions: quizQuestions[counter].answers,
      answer: ''
    });
  }

  setNextQuestion() {
    const counter = this.state.counter + 1;
    const questionId = this.state.questionId + 1;
    
    this.setState({
      counter: counter,
      questionId: questionId,
      question: quizQuestions[counter].question,
      answerOptions: quizQuestions[counter].answers,
      answer: ''
    });
  }

  getProductResult() {
    const answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);
    var result = '';
    
    if (answersCountKeys.includes("sheer")) {
      result = 'powder';
    } else if (answersCountKeys.includes("medium-to-full")) {
      result = 'flawless';
    } else if (answersCountKeys.includes("full")) {
      result = 'matte';
    }

    return result;
  }

  getResults() {
    var answersCount = this.state.answersCount;
    const answersCountKeys = Object.keys(answersCount);

    var productResult = this.getProductResult();
    var shadeResult = '';
    
    if (answersCountKeys.includes("cream-beige")) {
      shadeResult = 'cream-beige';
    } else if (answersCountKeys.includes("tender-beige")) {
      shadeResult = 'tender-beige';
    } else if (answersCountKeys.includes("almond")) {
      shadeResult = 'almond';
    } else if (answersCountKeys.includes("sandy-beige")) {
      shadeResult = 'sandy-beige';
    } else if (answersCountKeys.includes("golden-honey")) {
      shadeResult = 'golden-honey';
    } else if (answersCountKeys.includes("golden-beige")) {
      shadeResult = 'golden-beige';
    } else if (answersCountKeys.includes("brown-sugar")) {
      shadeResult = 'brown-sugar';
    } else if (answersCountKeys.includes("rich-bronze")) {
      shadeResult = 'rich-bronze';
    } else if (answersCountKeys.includes("dark-coffee")) {
      shadeResult = 'dark-coffee';
    } else if (answersCountKeys.includes("cocoa")) {
      shadeResult = 'cocoa';
    }

    if (answersCountKeys.includes("sheer")) {
      this.setState({ answerOne: "Sheer" })
    } else if (answersCountKeys.includes("medium-to-full")) {
      this.setState({ answerOne: "Medium To Full" })
    } else if (answersCountKeys.includes("full")) {
      this.setState({ answerOne: "Full" })
    }

    if (answersCountKeys.includes("natural")) {
      this.setState({ answerTwo: "Natural" })
    } else if (answersCountKeys.includes("luminous")) {
      this.setState({ answerTwo: "Luminous" })
    } else if (answersCountKeys.includes("matte")) {
      this.setState({ answerTwo: "Matte" })
    }

    if (answersCountKeys.includes("brush")) {
      this.setState({ answerThree: "Brush" })
    } else if (answersCountKeys.includes("sponge")) {
      this.setState({ answerThree: "Sponge" })
    } else if (answersCountKeys.includes("fingers")) {
      this.setState({ answerThree: "Fingers" })
    }

    if (productResult == 'matte') {
      this.setState({
        brushImage: "https://i.imgur.com/tOcVu5g.png",
        brushLink: "https://bovanticosmetics.com/products/brushes?variant=31866703413330",
        brush: "Buffer Brush"
      })

      switch (shadeResult) {
        case 'cream-beige':
          productResult = 'flawless';
          break;
        case 'tender-beige':
          shadeResult = 'golden-olive';
          break;
        case 'almond':
          shadeResult = 'deep-olive';
          break;
        case 'sandy-beige':
          shadeResult = 'amaretto';
          break;
        case 'golden-honey':
          shadeResult = 'egyptian-bronze';
          break;
        case 'golden-beige':
          productResult = 'flawless';
          break;
        case 'brown-sugar':
          shadeResult = 'warm-cognac';
          break;
        case 'rich-bronze':
          shadeResult = 'hazelnut';
          break;
        case 'dark coffee':
          shadeResult = 'rich kalua';
          break;
        case 'cocoa':
          productResult = 'flawless';
          break;
        default:
          break;
      }
    } else if (productResult == 'powder') {
      this.setState({
        brushImage: "//cdn.shopify.com/s/files/1/0247/5376/6482/products/powder_brush_800x800@2x.png",
        brushLink: "https://bovanticosmetics.com/products/brushes?variant=31866703446098",
        brush: "Super Dome Brush"
      })

      switch (shadeResult) {
        case 'cream-beige':
          shadeResult = 'cream';
          break;
        case 'tender-beige':
          shadeResult = 'cream';
          break;
        case 'almond':
          shadeResult = 'pecan';
          break;
        case 'sandy-beige':
          shadeResult = 'pecan';
          break;
        case 'golden-honey':
          shadeResult = 'tan';
          break;
        case 'golden-beige':
          shadeResult = 'tan';
          break;
        case 'brown-sugar':
          shadeResult = 'golden-tan';
          break;
        case 'rich-bronze':
          shadeResult = 'amber';
          break;
        case 'dark coffee':
          shadeResult = 'java';
          break;
        case 'cocoa':
          shadeResult = 'milk-chocolate';
          break;
        default:
          break;
      }
    } else if (productResult == 'flawless') {
      this.setState({
        brushImage: "https://i.imgur.com/tOcVu5g.png",
        brushLink: "https://bovanticosmetics.com/products/brushes?variant=31866703413330",
        brush: "Buffer Brush"
      })
    }

    return [shadeResult, productResult];
  }

  setResults (results) {
    const shadeShadeMap = shadeInfo.map(shade => shade.shade);
    const shadeColorMap = shadeInfo.map(shade => shade.color);
    const shadeImageMap = shadeInfo.map(shade => shade.image);
    const shadeLinkMap = shadeInfo.map(shade => shade.link);

    const index = shadeShadeMap.findIndex(element => element == results[0]);

    console.log(index);

    const shadeColor = shadeColorMap[index];
    const shadeImage = shadeImageMap[index];
    const shadeLink = shadeLinkMap[index];

    const shadeResultPolished = results[0]
      .replace(/-/g, ' ');

    this.setState({ shadeResult: results[0],
      shadeResultPolished: shadeResultPolished,
      productResult: results[1],
      shadeColor: shadeColor,
      shadeLink: shadeLink,
      shadeImage: shadeImage
    });
  }

  handleAnswerSelected(event) {
    event.preventDefault();
    this.setUserAnswer(event.currentTarget.getAttribute('value'));
    
    if (this.state.questionId < quizQuestions.length) {
        this.setNextQuestion();
      } else {
        this.setState({ pageId: this.state.pageId + 1 });
      }
  }

  handleContinueSelected(event) {
    this.setState({ pageId: this.state.pageId + 1 });
  }

  handleLoadingSelected(event) {
    this.setState({ pageId: 4 });
  }

  handleBackSelected(event) {
    this.setState({ 
      pageId: 0,
      answersCount: {},
      counter: 0,
      questionId: 1,
      question: quizQuestions[0].question,
      answerOptions: quizQuestions[0].answers,
      answer: '' });
  }

  handleBackQuizSelected(event) {
    if (this.state.questionId == 1) {
      this.setState({ pageId: this.state.pageId - 1 });
    } else {
      this.setPreviousQuestion();
    }
  }

  handleModelSelected(value) {
    this.setUserAnswer(value);
    setTimeout(() => this.setResults(this.getResults()), 300);
    this.setState({ modelSelected: value, pageId: this.state.pageId + 1 });
  }

  renderIntroduction() {
    return (
      <Introduction
        onContinueSelected={this.handleContinueSelected}
      />
    );
  }

  renderExplanation() {
    return (
      <Explanation
        onContinueSelected={this.handleContinueSelected}
        onBackSelected={this.handleBackSelected}
      />
    )
  }

  renderSkintone() {
    return (
      <Skintone
        onContinueSelected={this.handleContinueSelected}
        onBackSelected={this.handleBackSelected}
        onModelSelected={this.handleModelSelected}
      />
    )
  }

  renderModelSelect() {
    return (
      <ModelSelect
        onContinueSelected={this.handleContinueSelected}
        onBackSelected={this.handleBackSelected}
      />
    )
  }

  renderQuiz() {
    return (
      <Quiz
        answer={this.state.answer}
        value={this.state.value}
        answerOptions={this.state.answerOptions}
        questionId={this.state.questionId}
        question={this.state.question}
        questionTotal={quizQuestions.length}
        onAnswerSelected={this.handleAnswerSelected}
        onBackQuizSelected={this.handleBackQuizSelected}
      />
    );
  }

  renderLoading() {
    setTimeout(this.handleLoadingSelected, 10000);
    return (
      <Loading />
    );
  }
  
  renderResult() {
    return (
      <Result
        shadeResult={this.state.shadeResultPolished}
        shadeColor={this.state.shadeColor}
        shadeLink={this.state.shadeLink}
        shadeImage={this.state.shadeImage}
        productResult={this.state.productResult}
        onBackSelected={this.handleBackSelected}
        brush={this.state.brush}
        brushImage={this.state.brushImage}
        brushLink={this.state.brushLink}
        answerOne={this.state.answerOne}
        answerTwo={this.state.answerTwo}
        answerThree={this.state.answerThree}
      />
    );
  }

  renderPage() {
    switch(this.state.pageId) {
      case 0:
        return this.renderIntroduction();
      case 1:
        return this.renderQuiz();
      case 2:
        return this.renderSkintone();
      case 3:
        return this.renderLoading();
      case 4:
        return this.renderResult();
      default:
        return this.renderIntroduction();
    }
  }
  
  render() {
    return (
      <div className="App">
        { this.renderPage() }
      </div>
    )
  }
}

export default App;
